import type { ActivityItem, BoostSummary, Candle, LaunchSummary, ProtocolStats } from "@bubblefun/shared";

const addresses = [
  "0x2a3A58829A6ED603eB2135EDC2f9502d77C63b0b",
  "0x8FD74170635DD88B884782f5927AcD0F50A18b0b",
  "0x07bE322A043C772257c2E30F97B72AA440802b0b",
  "0xA32fE65022B34Be8a761C20b1714a3BB4df19b0b",
  "0x746A87C3df875BA46EC344C0ab95014f0396Bb0b",
  "0x9DdA4d3293C146b568851F8C9110298891777b0b"
] as const;

export const demoLaunches: LaunchSummary[] = [
  {
    address: addresses[0], creator: "0x2De33aB901dAeC29246C74a39F972e6fE9aE3021", pool: "0x5a1282B084f4f80a774aF6d991EC1EEAdc7E4881", positionId: "1",
    name: "Paper Plane", symbol: "PLANE", description: "A fast little market with nowhere to hide the liquidity.",
    logoUri: "", website: "https://example.com", twitter: "", telegram: "", priceEth: 0.00000000482,
    fdvEth: 4.82, marketCapUsd: 13_530, volume24hEth: 8.4, volume24hUsd: 23_579, change24h: 18.6, marketProgress: 100, holders: 483,
    createdAt: "2026-07-13T08:22:00Z", status: "milestone"
  },
  {
    address: addresses[1], creator: "0xb3d5D13b69aB2e33CC8F97dBA85559f879Ea4071", pool: "0x91B43435d69199191CE6919f747a327C4b19Aa0E", positionId: "2",
    name: "Red Thread", symbol: "THREAD", description: "Follow the onchain thread. The position stays locked.",
    logoUri: "", website: "", twitter: "https://x.com", telegram: "", priceEth: 0.00000000291,
    fdvEth: 2.91, marketCapUsd: 8_169, volume24hEth: 3.1, volume24hUsd: 8_702, change24h: 7.3, marketProgress: 63, holders: 216,
    createdAt: "2026-07-13T09:41:00Z", status: "active"
  },
  {
    address: addresses[2], creator: "0x6bD6B91EAbBD3C6124cBe46b3Fe19fc492c0A644", pool: "0x9acAdC7AEb44048B84891361882049f39A73c4A0", positionId: "3",
    name: "Common Ground", symbol: "GROUND", description: "One supply, one market, one permanent position.",
    logoUri: "", website: "", twitter: "", telegram: "", priceEth: 0.00000000234,
    fdvEth: 2.34, marketCapUsd: 6_570, volume24hEth: 1.8, volume24hUsd: 5_053, change24h: -3.8, marketProgress: 42, holders: 144,
    createdAt: "2026-07-13T10:06:00Z", status: "active"
  },
  {
    address: addresses[3], creator: "0xCddB908fC54A29E3E269c5D664B96cD07E6C4349", pool: "0x081b3aB57c0F636F86D82E8BeD28f7A36Cd41443", positionId: "4",
    name: "Tuesday Club", symbol: "TUES", description: "The club opens whenever the chain is awake.",
    logoUri: "", website: "", twitter: "", telegram: "", priceEth: 0.00000000192,
    fdvEth: 1.92, marketCapUsd: 5_390, volume24hEth: 0.91, volume24hUsd: 2_554, change24h: 2.1, marketProgress: 21, holders: 83,
    createdAt: "2026-07-13T10:52:00Z", status: "active"
  },
  {
    address: addresses[4], creator: "0xe46e3C12B5E2e2677afcb920aB28227972681611", pool: "0x96Fa614c0534fC43b13839d570CE7DAfBEf17C82", positionId: "5",
    name: "Blue Receipt", symbol: "RCPT", description: "Every rule is legible before the first signature.",
    logoUri: "", website: "", twitter: "", telegram: "", priceEth: 0.00000000168,
    fdvEth: 1.68, marketCapUsd: 4_717, volume24hEth: 0.44, volume24hUsd: 1_235, change24h: -1.2, marketProgress: 9, holders: 47,
    createdAt: "2026-07-13T11:17:00Z", status: "active"
  },
  {
    address: addresses[5], creator: "0x660928e9874d793F79220DC5D540991fc61B8EF0", pool: "0xb1274dcE006B20B83950F7Fb02Dd3639Cc07106e", positionId: "6",
    name: "Open Edition", symbol: "OPEN", description: "An early market shown without manufactured certainty.",
    logoUri: "", website: "", twitter: "", telegram: "", priceEth: 0.00000000152,
    fdvEth: 1.52, marketCapUsd: 4_268, volume24hEth: 0.18, volume24hUsd: 505, change24h: 0.6, marketProgress: 2, holders: 19,
    createdAt: "2026-07-13T11:43:00Z", status: "active"
  }
];

export const demoStats: ProtocolStats = {
  launches: 128,
  volumeEth: 418.6,
  volumeUsd: 1_175_010,
  creatorFeesEth: 11.42,
  lockedPositions: 128
};

const demoNow = Date.now();
export const demoBoosts: BoostSummary[] = [
  {
    id: "preview-boost-plane",
    token: addresses[0],
    buyer: demoLaunches[0].creator,
    packageId: 3,
    amountEth: 0.1,
    startsAt: new Date(demoNow - 18 * 60_000).toISOString(),
    endsAt: new Date(demoNow + 23 * 60 * 60_000 + 42 * 60_000).toISOString(),
    purchasedAt: new Date(demoNow - 18 * 60_000).toISOString()
  },
  {
    id: "preview-boost-thread",
    token: addresses[1],
    buyer: demoLaunches[1].creator,
    packageId: 1,
    amountEth: 0.05,
    startsAt: new Date(demoNow - 9 * 60_000).toISOString(),
    endsAt: new Date(demoNow + 5 * 60 * 60_000 + 51 * 60_000).toISOString(),
    purchasedAt: new Date(demoNow - 9 * 60_000).toISOString()
  },
  {
    id: "preview-boost-ground",
    token: addresses[2],
    buyer: demoLaunches[2].creator,
    packageId: 2,
    amountEth: 0.07,
    startsAt: new Date(demoNow - 31 * 60_000).toISOString(),
    endsAt: new Date(demoNow + 11 * 60 * 60_000 + 29 * 60_000).toISOString(),
    purchasedAt: new Date(demoNow - 31 * 60_000).toISOString()
  }
];

export const demoCandles: Candle[] = Array.from({ length: 72 }, (_, index) => {
  const drift = 1.5 + index * 0.035;
  const wave = Math.sin(index / 4.2) * 0.24 + Math.sin(index / 9) * 0.13;
  const close = Math.max(1.42, drift + wave);
  const previous = Math.max(1.42, 1.5 + (index - 1) * 0.035 + Math.sin((index - 1) / 4.2) * 0.24);
  return {
    time: Math.floor(Date.now() / 1000) - (71 - index) * 300,
    open: previous / 1_000_000_000,
    high: (Math.max(previous, close) + 0.08) / 1_000_000_000,
    low: (Math.min(previous, close) - 0.07) / 1_000_000_000,
    close: close / 1_000_000_000,
    volume: 0.02 + Math.abs(Math.sin(index)) * 0.12
  };
});

export const demoActivity: ActivityItem[] = [
  { id: "1", token: addresses[0], symbol: "PLANE", side: "buy", amountEth: 0.42, amountToken: 88_140_000, trader: "0x408c50A7bE50D88Af8563B9260f9C02028DF2B47", timestamp: "2026-07-13T22:58:00Z", transactionHash: "0x1111111111111111111111111111111111111111111111111111111111111111" },
  { id: "2", token: addresses[0], symbol: "PLANE", side: "sell", amountEth: 0.1762, amountToken: 36_800_000, trader: "0x65d18198e86bc81D60AC297EA057c072F42C1B26", timestamp: "2026-07-13T22:55:00Z", transactionHash: "0x2222222222222222222222222222222222222222222222222222222222222222" },
  { id: "3", token: addresses[0], symbol: "PLANE", side: "buy", amountEth: 1.08, amountToken: 211_340_000, trader: "0xe46e3C12B5E2e2677afcb920aB28227972681611", timestamp: "2026-07-13T22:51:00Z", transactionHash: "0x3333333333333333333333333333333333333333333333333333333333333333" },
  { id: "4", token: addresses[0], symbol: "PLANE", side: "buy", amountEth: 0.0634, amountToken: 13_190_000, trader: "0xF033Db6c8B685e18c8e3187A7F0cb1228A607E44", timestamp: "2026-07-13T22:47:00Z", transactionHash: "0x4444444444444444444444444444444444444444444444444444444444444444" },
  { id: "5", token: addresses[0], symbol: "PLANE", side: "sell", amountEth: 0.00872, amountToken: 1_820_000, trader: "0x1c9AAe0C97B29E8aAE74b13210B0A26fb48dA283", timestamp: "2026-07-13T22:42:00Z", transactionHash: "0x5555555555555555555555555555555555555555555555555555555555555555" },
  { id: "6", token: addresses[1], symbol: "THREAD", side: "buy", amountEth: 0.08, amountToken: 27_420_000, trader: "0x65d18198e86bc81D60AC297EA057c072F42C1B26", timestamp: "2026-07-13T22:39:00Z", transactionHash: "0x6666666666666666666666666666666666666666666666666666666666666666" }
];
